import { TeliaGrid } from '@teliads/components/react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import Page404 from './Page404';

import ErrorState from 'components/custom/error-state/ErrorState';

export default function ErrorScreenSample() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    switch (error.status) {
      case 404:
        return <Page404 />;
      default:
        return (
          <TeliaGrid>
            <ErrorState type={'fetchError'} />
          </TeliaGrid>
        );
    }
  } else {
    return <></>;
  }
}
